import { useEffect, useRef } from 'react';
import { useWallet } from '@solana/wallet-adapter-react';
import { useAppContext } from '../contexts/hooks';
import { setSentryUser } from '../sentry';

const USE_MOCK = import.meta.env.VITE_USE_MOCK === 'true';

export function useSolanaSync() {
  const { publicKey, connected } = useWallet();
  const { dispatch } = useAppContext();
  const prevAddress = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (USE_MOCK) return;

    const address = publicKey?.toBase58();

    if (connected && address && address !== prevAddress.current) {
      prevAddress.current = address;
      dispatch({ type: 'SYNC_CONNECTED_WALLET', chain: 'solana', address });
      setSentryUser(address, 'solana');
    }

    if (!connected && prevAddress.current) {
      prevAddress.current = undefined;
      dispatch({ type: 'DISCONNECT_CHAIN', chain: 'solana' });
      setSentryUser(null, null);
    }
  }, [connected, publicKey, dispatch]);
}
